import React from 'react';
import { Checkbox } from '@cimpress/react-components';

interface AutomaskProps {
    id?: string;
    active: boolean;
    enable: boolean;
    toggle: (id: string) => void;
}

const Automask: React.FC<AutomaskProps> = ({ id, active, enable, toggle }) => {
    const handleToggle = () => {
        toggle(id!);
    };

    if (!enable) return <></>;

    return (
        <div className='automask'>
            <Checkbox
                type='secondary'
                style={{ marginBottom: '24px' }}
                checked={active}
                onClick={handleToggle}
                label='Use Auto Mask'
            />
        </div>
    );
};

export default React.memo(Automask);
